export default {"src":"/_next/static/media/star-decoration.20607f31.svg","height":63,"width":55,"blurWidth":0,"blurHeight":0};